module.exports = __webpack_public_path__ + "static/media/EULR.7edd58d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/EULR.jpg
// module id = 1742
// module chunks = 1